// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".region-search .s-main[data-v-6df7b372] {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-content: flex-start;\n  background: #fff;\n}\n.region-search .s-main .m-item[data-v-6df7b372] {\n  margin-top: 4vw;\n}\n.region-search .s-main .m-item[data-v-6df7b372]:nth-of-type(n + 1) {\n  margin-left: 4vw;\n}\n", ""]);
// Exports
module.exports = exports;
